import React from 'react'
import classes from "./ReportHeader.module.css";
import { FaArrowLeft } from "react-icons/fa";
import { IoMdCloudDownload } from "react-icons/io";

const ReportHeader = ({ handlePrint, onBack }) => {
    return (
        <div className={`${classes.topActions} no-print`}>
            {onBack && <span onClick={onBack} className={classes.backButton}>
                <FaArrowLeft color={"#fff"} />
            </span>}
            {handlePrint && <span className={classes.mlAuto}  onClick={handlePrint}>
                <IoMdCloudDownload color={"#fff"} />
            </span>}
        </div>
    )
}

export default ReportHeader